// import { JSEncrypt } from 'jsencrypt';

const encryptionProcessing = (context) => {
  const encrypt = new window.JSEncrypt();
  encrypt.setPublicKey(
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGd4XG9f3OMhr5UXXKWFiSBqBgEiJCn0MzO4386+/g6foWgY8dyw5c93W/wGBB5x2CSPNLm+YCKiH10VIo4TdSQBD0PlsrffR/4VRR1iNDiK4SlOH0f673sEMu+EKsDEMSEMxHqtHEw2/yl2pKEqYmA/vIPUnHNFTwlShqxWcm0QIDAQAB'
  );
  return encrypt.encrypt(context);
};

export default function useJsencrypt(contenxt) {
  return encryptionProcessing(contenxt);
}
